import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const Cross = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g strokeWidth="3.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="m31.25 8.75-22.5 22.5M31.25 31.25 8.75 8.75" />
    </g>
  </svg>);
export default Cross;